<template>
  <div class="smsHistory">
    <div class="col-md-12 row">
      <div class="my-2 p-0">
        <b-alert dismissible variant="secondary" show>
          <b-icon icon="shield-exclamation"></b-icon>
          Due to the new regulation issued by the SMS service provider, we will be sending verified SMS only to comply with that. From now onwards, you can only be able to send verified SMS from the template. 
          Please select the SMS template from below to begin.
        </b-alert>
      </div>
      <div
        id="content"
        class="col-md-4 px-2 pt-2"
        style="min-height:200px;max-height:500px;overflow:scroll"
      >
        <div class="d-flex m-0 p-0">
          <input
            type="text"
            v-model="searchTemplate"
            placeholder="search template"
            class="form-control"
          />
          <b-dropdown id="dropdown-dropleft" no-caret dropleft variant="default" class="ml-2 border">
            <template slot="button-content">
                <b-icon icon="filter-right"></b-icon>
            </template>
            <b-dropdown-text style="width: 240px;">
              Filter with corresponsing Funnel
            </b-dropdown-text>
            <b-alert class="mx-2" show variant="danger">Yet not functioning.</b-alert>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button>Failed Booking</b-dropdown-item-button>
            <b-dropdown-item-button>Expired Booking</b-dropdown-item-button>
            <b-dropdown-item-button>Generic</b-dropdown-item-button>
          </b-dropdown>
        </div>
        <div
        style="cursor:pointer"
          class="card p-2 my-2"
          v-for="(data, index) in filteredTemplate"
          :key="index"
          @click="selectTemplate(data)"
          v-bind:class="{ active: data == currentTemplate }"
        >
          <div class="d-flex m-0 p-0" v-if="data == currentTemplate">
            <b-icon class="pt-0 mt-1 mr-2" icon="check-circle"></b-icon>
            <span class="">Selected</span>
          </div>
          <p class="m-0 p-0 mb-2">
            <b-badge>{{ data.name }}</b-badge>
          </p>
          <p>{{ data.template }}</p>
        </div>
        <div v-if="loading" class="col-md-12 py-5">
          <p>We are still loading template for you!</p>
        </div>
      </div>
      <div class="col-md-8 px-2 pt-2 m-0">
        <div
          class="col-md-12 p-2 m-0  border"
          style="min-height:300px;max-height:300px;overflow:scroll"
        >
          <h5>SMS Logs</h5>
          <div class="mt-5 text-center" v-if="loading">
            We are loading.
          </div>
          <div v-if="sentMessages.length > 0 && !loading">
            <div
              class="card p-2 show-cursor my-2"
              v-for="(data, index) in sentMessages"
              :key="index"
            >
              <p>{{ data.message }}</p>
              <em>{{ data.agent.name }} on {{ data.createdAt | moment("LL") }}</em>
            </div>
          </div>
          <div
            class="mt-5 text-center"
            v-if="!loading && sentMessages.length == 0"
          >
            <b-icon
              icon="chat-left-dots"
              style="width: 30px; height: 30px;"
            ></b-icon>
            <p>We haven't sent any message to the customer.</p>
            <p v-if="!id">No customer Selected</p>
          </div>
        </div>

        <div class="my-4 col-md-12 row" v-if="currentTemplate">
          <div class="col-md-6">
            <div class="col-md-12 m-0 p-0">
              <b-alert show variant="warning">
                <b-icon icon="exclamation-circle-fill"></b-icon>
                Important: Please don't skip this part.</b-alert
              >
            </div>
            <div class="col-md-12 m-0 p-0 my-2">
              <p class="m-0 p-0">Sending SMS to</p>
              <b-input-group>
                <b-form-input
                  type="number"
                  :disabled="!mobileEditMode"
                  v-model="mobile"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="mobileEditMode = !mobileEditMode"
                    variant="outline-secondary"
                  >
                    <b-icon v-b-tooltip="'Edit Mobile'" v-if="!mobileEditMode" icon="pencil"></b-icon>
                    <b-icon v-b-tooltip="'Lock this number'" icon="lock" v-else ></b-icon>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div v-if="requireVAR1" class="col-md-12 m-0 p-0 my-2">
              Enter {{ currentTemplate.VAR1 }}
              <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="VAR1"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-dropdown
                      variant="outline-secondary"
                      text="Auto Fill"
                    >
                      <b-dropdown-item @click="VAR1 = data" v-for="(data,key, index) in metaData" :key="index">
                        {{key}}:
                        {{data}}</b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
            </div>
            <div v-if="requireVAR2" class="col-md-12 m-0 p-0 my-2">
              Enter {{ currentTemplate.VAR2 }}
              <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="VAR2"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-dropdown
                      variant="outline-secondary"
                      text="Auto Fill"
                    >
                      <b-dropdown-item @click="VAR2 = data" v-for="(data, key, index) in metaData" :key="index">
                        {{key}}:
                        {{data}}</b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
            </div>
          </div>
          <div class="col-md-6">
      <div class="col-md-12 my-2 p-0" v-if="currentTemplate">
        <div class="col-md-12 m-0 p-0">
          <p class="m-0 p-0">SMS Preview</p>
          <p style="color:gray;font-size:13px">
            Your SMS will be delivered something like:
          </p>
          <b-alert variant="info" show>
            {{ `${currentTemplate.template}` }}
            <div>
              <p v-if="requireVAR1" class="m-0 p-0">#VAR1 : {{ VAR1 }}</p>
              <p v-if="requireVAR2" class="m-0 p-0">#VAR2 : {{ VAR2 }}</p>
            </div>
          </b-alert>
        </div>
        <div>
          <div class="col-md-12 m-0 p-0">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="warning"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p>Message sent to {{ mobile }}, alert dismisses after {{ dismissCountDown }} seconds</p>
            <b-progress
              variant="warning"
              :max="dismissSecs"
              :value="dismissCountDown"
              height="4px"
            ></b-progress>
          </b-alert>
          </div>
          <b-button @click="sendSms">I am sure, send this SMS</b-button>
        </div>
      </div>
      </div>
      <div class="col-md-12 m-0 p-0" v-if="!id">
        <b-alert show variant="success">
          <h4 class="alert-heading">Caution!</h4>
          <p>
            You are sending sms without selecting the customer, the message will be deliverd to the prefered phone number but 
            will not be reflected in any of the customer profile.
          </p>
        </b-alert>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // sentMessages: "",
      // loading: true,
      currentTemplate: null,
      requireVAR1: false,
      requireVAR2: false,
      VAR1: "",
      VAR2: "",
      searchTemplate: "",
      mobile: null,
      mobileEditMode: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showMessageSentAlert: false
    };
  },
  created() {
    if(this.id!= null){
      this.fetchMessages(this.id)
    }
    this.mobile = this.metaData.mobile;
    this.metaData['Location'] = 'https://bit.ly/3xfphu7'
    this.$store.dispatch("get_template_data", {});
  },
  props: {
    id: Number,
    metaData: Object,
  },
  methods: {
    fetchMessages(id) {
      this.$store.dispatch('get_sms_data', {customer: id})
    },
    selectTemplate(data) {
      this.variables = [];
      this.requireVAR1 = data.variables[0].required;
      this.requireVAR2 = data.variables[1].required;
      this.currentTemplate = data;
    },
    sendSms() {
      var obj = {
        flow: this.currentTemplate.flow,
        mobile: this.mobile,
        customer: this.id,
        variables: [this.VAR1, this.VAR2],
      };
      this.$store.dispatch("SEND_SMS", obj).then(()=>{
        this.dismissCountDown = this.dismissSecs
      }).catch(()=>{
        this.dismissCountDown = this.dismissSecs
      })
      console.log(obj);
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
  },
  computed: {
    loading() {
      return this.$store.state.loading_api
    },
    sentMessages() {
      return this.$store.state.smsData || []
    },
    templatesData() {
      return this.$store.state.get_template_data || []
    },
    filteredTemplate() {
      return this.templatesData.filter((x) => {
        return x.template
          .toLowerCase()
          .includes(this.searchTemplate.toLowerCase());
      });
    }
  },
};
</script>

<style scoped>
.smsHistory {
  font-size: 14px;
}
.smsHistoryContainer {
  min-height: 200px;
}
.active {
  background: #7977c2;
  color: white;
}
::-webkit-scrollbar {
  display: none;
}
.show-cursor {
  cursor: pointer;
}
</style>
